const ReverseDateString = (date) => {
  if (date) return date.split("-").reverse().join("-");
  else return "NA";
};

export default ReverseDateString;
